module.exports = __webpack_public_path__ + "img/98coupon.65c1b8c5.png";